<script setup lang="ts">
import type { ButtonShellProps } from '.';

defineProps<ButtonShellProps>();
defineSlots<{ default: () => void; icon: () => void }>();
</script>

<template>
  <button type="button" class="size-max overflow-hidden rounded-[100px]">
    <AppButtonShell :transition :theme>
      <slot />
      <slot name="icon" />
    </AppButtonShell>
  </button>
</template>
